<template>
  <v-card align="center" justify="center" min-width="20vw" outlined>
    <v-card-title >
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_LinkMetaTrader') }} {{ brokerAccount.broker.name }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-form v-model="valid">
        <v-img class="mb-5" src="https://images.squarespace-cdn.com/content/v1/5d849fb37a733a2e699b3774/1588861945863-2ID74IHT0Y1VGKLYE497/Metatrader4?format=1000w" max-width="70"/>
        <v-select :label="$t('versionLabel')" :items="versions" item-text="text" item-value="value" disabled
                  v-model="version" :rules="versionRules" outlined/>
        <v-select :label="$t('serverLabel')" :items="servers" item-text="name" item-value="host"
                  v-model="server" :rules="serverRules" outlined/>
        <v-text-field :label="$t('loginLabel')" :placeholder="$t('loginPlaceholder')"
                      v-model="login" :rules="loginRules" outlined/>
        <v-text-field :label="$t('investorPasswordLabel')" :placeholder="$t('investorPasswordPlaceholder')"
                      v-model="investorPassword" :rules="investorPasswordRules" outlined/>
        
        <p style="font-size: 15px;" class="text-start mb-7" v-html="$t('complianceMessageUrl')"/>
        <v-btn :disabled="!valid" class="mt-2" @click="linkMetaTrader">{{ $t('btnLink') }}</v-btn>
      </v-form>
    </v-card-text>
    <v-overlay :dark="false" v-model="waitingRequest">
        <lottie :options="lottieOptions" :height="250" :width="250"/>
    </v-overlay>
  </v-card>
</template>

<script>
import * as animationData from '@/assets/animations/loading.json';
import Repository from '../../../repositories/metaTraderCredentials';

export default {
  name: "LinkMetaTrader",
  props: {
    brokerAccount: Object,
  },
  data() {
    return {
      lottieOptions: { animationData: animationData.default, },
      waitingRequest: false,
      existingCredentialsId: -1,
      servers: [
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo', host: 'demo.ava-mt.com' },
        //{ name: 'Ava-Demo 2', host: 'demo.ava-mt-2.com' },
        //{ name: 'Equiti-Demo', host: 'demo.equiti-demo.com' },
        //{ name: 'Equiti-Live', host: 'demo.equiti-live.com' },
        //{ name: 'EquitiGroup-Demo', host: 'demo.equitigroup-demo.com' },
        //{ name: 'EquitiGroup-Live', host: 'demo.equitigroup-live.com' },
        //{ name: 'EquitiGroup-Live 2', host: 'demo.equitigroup-live-2.com' },
        { name: 'ZenfinexGlobal-Demo', host: '52.56.239.235' },
        { name: 'ZenfinexGlobal-Live', host: '18.168.113.125' },
        { name: 'WorldTraders-Demo', host: '51.91.105.144' },
      ],
      versions: [
        { text: 'MetaTrader 4', value: 'MT4' },
        { text: 'MetaTrader 5', value: 'MT5' },
      ],
      server: '',
      login: '',
      investorPassword: '',
      version: '',
      // Validation
      valid: false,
      versionRules: [
        v => !!v || this.$t('validations.versionMandatory'),
      ],
      serverRules: [
        s => !!s || this.$t('validations.serverMandatory'),
      ],
      loginRules: [
        l => !!l || this.$t('validations.loginMandatory'),
        l => (l && l.length <= 15) || this.$t('validations.loginMaxLength'),
      ],
      investorPasswordRules: [
        i => i.length <= 25 || this.$t('validations.investorPasswordMaxLength'),
      ],
      checkboxRules: [
        c => !!c || this.$t('validations.checkboxMandatory'),
      ],
    };
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.server = this.servers[0].host;
      this.version = this.versions[0].value;
      Repository.getCredentialsByBrokerAccountId(this.brokerAccount.id).then((response) => {
        if(response.status < 400) {
          let retrievedCredentials = response.data;
          this.server = retrievedCredentials.server;
          this.login = retrievedCredentials.login;
          this.investorPassword = retrievedCredentials.password;
          this.existingCredentialsId = retrievedCredentials.id;
          this.version = retrievedCredentials.version;
        }
      });
    },
    linkMetaTrader() {
      let metaTraderCredentials = {
        brokerAccount: { id: this.brokerAccount.id },
        server: this.server,
        login: this.login,
        password: this.investorPassword,
        version: this.version,
      };

      if(this.existingCredentialsId !== -1)
        metaTraderCredentials.id = this.existingCredentialsId;

      this.waitingRequest = true
      let promise = (this.existingCredentialsId === -1)? Repository.createCredentials(metaTraderCredentials) : Repository.updateCredentials(metaTraderCredentials);
      promise.then((response) => {
        if(response.status < 400) {
          alert((this.existingCredentialsId === -1)? this.$t('alerts.successfullyCreated') : this.$t('alerts.successfullyModified'));
          this.close();
        }
        this.waitingRequest = false
      })
      promise.catch((error) => {
          let errorKey = error.response.data.errorKey
          if(errorKey==='idexists'){
            alert(this.$t('alerts.errors.idexists'));
          }else if(errorKey==='metacredentialInvalid'){
            alert(this.$t('alerts.errors.metacredentialInvalid'));
          }else{
            alert(this.$t('alerts.errors.genError'));
          }
          this.waitingRequest = false;
      })
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped>

</style>
